<script>
  import { initializeApp } from "firebase/app";
  import {
    getFirestore,
    getDoc,
    doc,
    addDoc,
    updateDoc,
    serverTimestamp,
    increment,
    collection,
    getDocs,
    runTransaction,
    writeBatch,
    setDoc,
  } from "firebase/firestore/lite";

  const firebaseConfig = {
    apiKey: "AIzaSyCws39J-cambnP0baMzvGnwybBkn2sFP0c",
    authDomain: "virtual-confirm.firebaseapp.com",
    projectId: "virtual-confirm",
    storageBucket: "virtual-confirm.appspot.com",
    messagingSenderId: "61094073873",
    appId: "1:61094073873:web:ed1d7f9e3a650e91e343b0",
    measurementId: "G-YSDMBR65HE",
  };

  //var start= performance.now()

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
 let codes=[];
  GetCodes();

  async function GetCodes() {

    let codes2=[];

    const codeDocuments = await getDocs(collection(db, "UsedCodes"));
    codeDocuments.docs.forEach((doc) => {
      codes2.push(doc.data());
    });
    codes=codes2;
  }


</script>

<section class="section">
    <div class="container">


        

    
        <table class="table">
        
            <thead>
                <tr>
                    <th>Datum</th>
                    <th>Klockan</th>
                    <th>Kod</th>
                </tr>
            </thead>
            <tbody>
        
                {#each codes as codeDoc}
                    <tr>
                        <!-- <td>{codeDoc.created.toDate()}</td> -->
                        <td>{codeDoc.created.toDate().toLocaleDateString()}</td>
                        <td>{codeDoc.created.toDate().toLocaleTimeString()}</td>
                        <td>{codeDoc.code}</td>
                        
                    </tr>
                {/each}
            </tbody>
        </table>
        
    </div>
</section>
